import React from 'react';
import NumberFormat from 'react-number-format';
import NumericInput from "react-numeric-input";

const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
const arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

class FloatingLabelInput extends React.Component {
    disabled = false;

    constructor(props) {
        super(props);
        this.state = {
            className: "",
            accept: "",
            error: ""
        };
        this.handleInput = this.handleInput.bind(this);
    }

    componentDidMount() {
        this.disabled = !!this.props.disabled;
    }

    componentDidUpdate() {
        if (this.props.value !== '') {
            if (this.state.className !== "on") {
                this.setState({ className: "on" });
            }
        } else {
            if (this.state.className !== "") {
                this.setState({ className: "" });
            }
        }
    }

    fixNumbers = (str) => {
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };

    handleInput(evt) {
        if (this.props.regxInput) {
            const value = typeof evt === 'string' ? evt : evt.target.value;
            if (value.match(this.props.regxInput)) {
                this.setState({ accept: "صحیح", error: "" });
            } else {
                this.setState({ accept: "", error: "اشتباه" });
            }
        }
    }

    render() {
        const { placeholder, value, handleInputt, type, require, error, helperText } = this.props;

        const inputStyle = {
            width: "100%",
            border: error ? "1px solid red" : undefined,
            borderRadius: "4px",
            padding: "12px 8px", // افزایش ارتفاع
            fontSize: "14px",    // تنظیم فونت برای خوانایی بهتر
            height: "55px"       // ارتفاع ثابت (دلخواه)
        };

        return (
            <div className="floatingLabelInput">
                <div style={{ width: "50%" }}>
                    <label className={this.state.className}>
                        {placeholder}
                        {" "}
                        <font color='red'>{this.state.error}</font>
                        <font color='green'>{this.state.accept}</font>
                    </label>
                </div>
                <div style={{ width: "50%" }}>
                    {require === "1" ? (
                        <label className="on">
                            <font size="2" color="green">اختیاری</font>
                        </label>
                    ) : null}
                </div>

                <div style={{ width: "100%" }}>
                    {type === "number" ? (
                        <NumberFormat
                            value={value}
                            placeholder={placeholder}
                            suffix=""
                            allowLeadingZeros
                            thousandSeparator={false}
                            style={inputStyle}
                            disabled={this.props.disabled}  // این رو اضافه کن
                            onValueChange={(e) => {
                                handleInputt(e.value);
                                this.handleInput(e.value);
                            }}
                        />
                    ) : type === "currency" ? (
                        <NumberFormat
                            placeholder={placeholder}
                            value={value}
                            suffix=" ریال"
                            thousandSeparator
                            style={inputStyle}
                            disabled={this.props.disabled}  // این رو اضافه کن
                            onValueChange={(e) => {
                                handleInputt(e.value);
                                this.handleInput(e.value);
                            }}
                        />
                    ) : type === "percent" ? (
                        <NumberFormat
                            placeholder={placeholder}
                            value={value}
                            suffix=" %"
                            thousandSeparator
                            style={inputStyle}
                            disabled={this.props.disabled}  // این رو اضافه کن
                            onValueChange={(e) => {
                                handleInputt(e.value);
                                this.handleInput(e.value);
                            }}
                        />
                    ) : (
                        <input
                            style={inputStyle}
                            disabled={this.props.disabled}
                            placeholder={placeholder}
                            value={value}
                            onChange={(e) => {
                                handleInputt(e);
                                this.handleInput(e);
                            }}
                        />
                    )}

                    {error && (
                        <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {helperText}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default FloatingLabelInput;
